import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';


export const defaultState = fromJS({
    isEditing: false,
    isFetching: false,
    results: [],
    selected: null,
    message: undefined,
    author_id: null,
});

export default handleActions({
    AUTHOR: {
        SET: (state, { payload }) => state.set('selected', fromJS(payload)),
        EDITING: {
            TOGGLE: state => state.set('isEditing', !state.get('isEditing')),
        },
        FETCHING: {
            ON: state => state.set('isFetching', true),
            OFF: state => state.set('isFetching', false),
        },
        SEARCH: {
            RESULTS: {
                SET: (state, { payload }) => state.merge({
                    results: fromJS(payload),
                    message: 'No results found.',
                }),
                CLEAR: (state, { payload: { message } = { message: defaultState.get('message') } }) => state.merge({
                    results: defaultState.get('results'),
                    message,
                }),
            },
        },
        SET_AUTHOR_ID: (state, { payload }) => state.set('author_id', payload),
    },
}, defaultState);

